export const REQUEST = "REQUEST";
export const SUCCESS = "SUCCESS";
export const FAILURE = "FAILURE";
export const INITIAL = "INITIAL";
export const OPEN = "OPEN";
export const CLOSE = "CLOSE";
export const SKIP = "SKIP";

export const createRequestTypes = base => [INITIAL, REQUEST, SUCCESS, FAILURE, SKIP].reduce((acc, type) => {
  acc[type] = `${base}_${type}`;
  return acc;
}, {});

export const createDialogTypes = base => [OPEN, CLOSE].reduce((acc, type) => {
  acc[type] = `${base}_${type}`;
  return acc;
}, {});

export const action = (type, payload = {}) => ({ type, payload });
